import { ThemeProvider } from '@mui/material';
import BackdropLoader from 'components/backdropLoader';
import { useCurrentBreakpoint } from 'hooks/useCurrentBreakpoint';
import { useGetSpacing } from 'hooks/useGetSpacing';
import { useTypographyFonts } from 'hooks/useGetTypographyFonts';
import { observer } from 'mobx-react-lite';
import mobxStore from 'mobx/rootStore';
import React from 'react';
import { UiContext } from 'uiContext';

function SizesComponent({ children }: { children: React.ReactNode }) {
  const currentBp = useCurrentBreakpoint();
  const spacingPreset = useGetSpacing({ currentBp });
  const { getFontSize } = useTypographyFonts({ currentBp });

  return (
    <UiContext.Provider
      value={{
        spacings: spacingPreset,
        getFontSize,
      }}
    >
      {children}
    </UiContext.Provider>
  );
}

const LoaderWrapper = observer(function LoaderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <BackdropLoader
        open={mobxStore.stateStore.isGlobalLoader}
      ></BackdropLoader>
      {children}
    </>
  );
});

export default observer(function UiWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ThemeProvider theme={mobxStore.uiStore.currentThemeVariant}>
      <SizesComponent>
        <LoaderWrapper>{children}</LoaderWrapper>
      </SizesComponent>
    </ThemeProvider>
  );
});
